import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

export default function VendorsSection() {
  const { t } = useTranslation();

  const benefits = [
    {
      icon: "ri-eye-line",
      title: t("vendors.benefit1_title"),
      desc: t("vendors.benefit1_desc"),
    },
    {
      icon: "ri-group-line",
      title: t("vendors.benefit2_title"),
      desc: t("vendors.benefit2_desc"),
    },
    {
      icon: "ri-rocket-line",
      title: t("vendors.benefit3_title"),
      desc: t("vendors.benefit3_desc"),
    },
    {
      icon: "ri-money-dollar-circle-line",
      title: t("vendors.benefit4_title"),
      desc: t("vendors.benefit4_desc"),
    },
    {
      icon: "ri-smartphone-line",
      title: t("vendors.benefit5_title"),
      desc: t("vendors.benefit5_desc"),
    },
  ];

  return (
    <section className="relative w-full py-20 md:py-28 bg-background-100">
      <div className="w-full px-4 md:px-6 lg:px-10 max-w-7xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center">
          {/* Left - Image */}
          <div className="relative order-2 lg:order-1">
            <div className="rounded-2xl overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Cameroonian%20female%20street%20food%20vendor%20proudly%20standing%20behind%20her%20food%20stall%20with%20traditional%20dishes%20colorful%20ingredients%20arranged%20beautifully%20warm%20natural%20lighting%20genuine%20smile%20confident%20posture%20authentic%20marketplace%20setting%20editorial%20portrait%20photography%20rich%20colors&width=700&height=800&seq=vendors-main-v2&orientation=portrait"
                alt="Local food vendor"
                className="w-full h-72 md:h-96 object-cover"
              />
            </div>
            <div className="absolute -bottom-5 -right-5 w-32 h-32 bg-accent-100/60 rounded-2xl -z-10"></div>
            <div className="absolute -top-5 -left-5 w-24 h-24 bg-primary-100/60 rounded-2xl -z-10"></div>
          </div>

          {/* Right - Content */}
          <div className="order-1 lg:order-2">
            <span className="inline-block px-4 py-1.5 rounded-full bg-accent-100 text-accent-800 text-xs font-semibold uppercase tracking-wider mb-5">
              {t("vendors.title")}
            </span>
            <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-foreground-950 mb-5 leading-tight">
              {t("vendors.title")}
            </h2>
            <p className="text-base md:text-lg text-foreground-600 mb-8 leading-relaxed">
              {t("vendors.subtitle")}
            </p>

            {/* Benefits List */}
            <div className="space-y-4 mb-8">
              {benefits.map((benefit, index) => (
                <div key={index} className="flex items-start gap-4">
                  <div className="w-10 h-10 rounded-lg bg-accent-100 flex items-center justify-center flex-shrink-0 mt-0.5">
                    <div className="w-5 h-5 flex items-center justify-center">
                      <i className={`${benefit.icon} text-accent-600`}></i>
                    </div>
                  </div>
                  <div>
                    <h4 className="font-heading text-sm font-semibold text-foreground-950 mb-0.5">
                      {benefit.title}
                    </h4>
                    <p className="text-sm text-foreground-600 leading-relaxed">
                      {benefit.desc}
                    </p>
                  </div>
                </div>
              ))}
            </div>

            <Link
              to="/vendors"
              className="inline-flex items-center gap-2 px-7 py-3.5 bg-accent-500 text-background-50 rounded-full text-sm font-semibold hover:bg-accent-600 transition-all hover:scale-105 shadow-lg shadow-accent-500/20 whitespace-nowrap cursor-pointer"
            >
              {t("vendors.cta")}
              <div className="w-4 h-4 flex items-center justify-center">
                <i className="ri-arrow-right-line"></i>
              </div>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}